<template>
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M-0.00195312 14.7515V18.5015H3.74805L14.808 7.44152L11.058 3.69152L-0.00195312 14.7515ZM17.708 4.54152C18.098 4.15152 18.098 3.52152 17.708 3.13152L15.368 0.791523C14.978 0.401523 14.348 0.401523 13.958 0.791523L12.128 2.62152L15.878 6.37152L17.708 4.54152Z"
      fill="black"
      fill-opacity="0.54"
    />
  </svg>
</template>
